// filepath: admin-dashboard/src/services/api/apiClient.ts
import axios from 'axios';
import { authService } from '../auth/authService';
import { getEnvironmentConfig } from '../../utils/envConfig';

// Get configuration from environment utility
const config = getEnvironmentConfig();
const API_BASE_URL = config.apiBaseUrl;

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add JWT token for authenticated requests
apiClient.interceptors.request.use(
  (config) => {
    const token = authService.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
  // On 401, clear the token — the AuthContext / ProtectedRoute will redirect
    if (error.response?.status === 401) {
      authService.logout();
      // Redirect to login unless we're already there
      if (!window.location.pathname.startsWith('/login')) {
        window.location.href = '/login';
      }
    }

    // Create a more helpful error object
    const detail = error.response?.data?.detail;
    const errorMessage =
      (typeof detail === 'string'
        ? detail
        : typeof detail === 'object' && detail?.message
          ? detail.message
          : Array.isArray(detail)
            ? detail.map((d: any) => d.msg || d.message).join('; ')
            : null) ||
      error.response?.data?.message ||
      error.message ||
      'Unknown error occurred';
    const status = error.response?.status;

    if (process.env.NODE_ENV !== 'production') {
      console.error(`API Error: ${status} - ${errorMessage}`, error);
    }

    const customError = new Error(errorMessage);
    (customError as any).status = status;
    (customError as any).originalError = error;
    return Promise.reject(customError);
  }
);